"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _daDesignSystem = require("@docaposte-agility/da-design-system");

var SelectTheme = function SelectTheme() {
  return {
    defaultProps: {
      IconComponent: function IconComponent(props) {
        return /*#__PURE__*/_react["default"].createElement(_daDesignSystem.CobaltIcon, (0, _extends2["default"])({
          name: "chevron-down"
        }, props));
      },
      inputProps: {
        sx: {
          display: 'flex',
          alignItems: 'center'
        }
      }
    },
    styleOverrides: {
      select: {
        height: '16px',
        minHeight: '16px'
      },
      icon: {
        color: 'inherit',
        right: '14px'
      }
    }
  };
};

var _default = SelectTheme;
exports["default"] = _default;